import {Fragment, useState, useCallback} from "react";
import {Redirect} from "react-router-dom";

import { CircularProgress, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2'

import Page from "../../components/Page";
import HelpTour from "../../components/HelpTour";
import useAuthenticatedRequest from "../../lib/useAuthenticatedRequest";
import {SITE_ROUTE} from "../../lib/routes";
import { useHelp } from "../../hooks/useHelpProvide";
import FiltersBar from "./FiltersBar";
import SitesGrid from "./SitesGrid";
import helpSteps from "./helpSteps";

export default function Sites() {
  const [{isLoading, data, error}] = useAuthenticatedRequest({
    method: "GET",
    url: "siteslist",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [toggleView, setToggleView] = useState(false);

  const {tourVisible} = useHelp();

  const onSearchTermChange = useCallback((newSearchTerm) => setSearchTerm(newSearchTerm), []);
  const onToggleView = useCallback(() => setToggleView(!toggleView), [toggleView]);

  const renderBody = () => {
    if (isLoading) {
      sessionStorage.removeItem("checkedVariables");
      sessionStorage.removeItem("selectedPeriod");
      return (
        <Grid container justify="center">
          <CircularProgress />
        </Grid>
      );
    }

    if (error) {
      return <h1>{error}</h1>
    }
////PER PRIMA COSA VERIFICO SE SERCHTERM è PRESENTE E IN CASO FILTRO I DATI
///CONVERTO IN MINUSCOLO E CERCO IN BASE A BRAND E NAME
    let results = data?.sites || [];

    if (searchTerm.trim() !== "") {
      results = results.filter(site => {
        const searchText = searchTerm.toLowerCase().split(' ');
        const brandName = `${site.brand} ${site.name}`.toLowerCase();
        return searchText.every(text => brandName.includes(text));
      });
    }
    ///SE SONO RAGGRUPPATI PER BRAND(TOGGLEVIEW === TRUE) ALLORA RAGGRUPPO I RISULTATI PER BRAND
    ///UTILIZZANDO IL REDUCE CHE METTE TUTTO DENTRO UN OGGETTO
    let sites;

    if (toggleView) {
      // Raggruppa per brand solo se non è in corso una ricerca
      const groupedByBrand = results.reduce((byBrand, site) => {
        const key = site.brand;
        byBrand[key] = byBrand[key] || [];
        byBrand[key].push(site);
        return byBrand;
      }, {});
      sites = groupedByBrand;
    } else {
      sites = results;
    }

    if (sites.length === 1) {
      return <Redirect to={SITE_ROUTE.computePath({siteId: sites[0].id})} />;
    }

    return (
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item size={12}>
          <FiltersBar
            onSearchTermChange={onSearchTermChange}
            toggleView={toggleView}
            onToggleView={onToggleView}
          />
        </Grid>
        {/* SE TOGGLEVIEW E DISATTIVATO VADO SEMPLICEMENTE A RENDERIZZARE SITESGRID
            SE INVECE è ATTIVO ITERO SU OGNI OGGETTO CHIAVE DELL'OGGETTO SITES E RENDERIZZO IN SITEGRID */}
        {!toggleView && <SitesGrid sites={sites} />}
        {toggleView && Object.entries(sites).map(([brand, brandSites]) => {
          if (brandSites.length > 0) {
            return (
              <Fragment key={brand}>
                <Grid item size={12}>
                  <Typography variant="h4" component="h2">
                    {brand} ({brandSites.length})
                  </Typography>
                </Grid>
                <SitesGrid sites={brandSites} />
              </Fragment>
            );
          }
          return null;
        })}
      </Grid>
    );
  }

  return (
    <Page lastChildren={
      <HelpTour
        show={!isLoading && tourVisible}
        steps={helpSteps}
      />
    }>
      {renderBody()}
    </Page>
  );
}



 